var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 783,
    height: 60,
    viewBox: "0 0 783 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4302_41854)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 58,
    height: 37,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 20.5,
    width: 59,
    height: 38,
    rx: 8.5,
    stroke: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.644 33.4713L66.9387 45.9936H63.6674L66.3731 33.4713H69.644ZM83.4075 41.557L85.1298 36.8544L86.1208 41.557H83.4075ZM87.0574 45.9936H90.0833L87.4429 33.4713H84.6499C84.0223 33.4713 83.4928 33.8327 83.257 34.39L78.3491 45.9936H81.7845L82.4665 44.1237H86.6636L87.0574 45.9936ZM78.5196 41.905C78.5336 38.5999 73.9039 38.418 73.9359 36.9416C73.9455 36.4918 74.3782 36.0146 75.3232 35.8921C75.7927 35.8315 77.0835 35.7851 78.5492 36.4529L79.1232 33.7975C78.3359 33.5145 77.3228 33.2422 76.0628 33.2422C72.8296 33.2422 70.5537 34.9445 70.5345 37.382C70.5141 39.1845 72.1592 40.1904 73.3988 40.7897C74.6732 41.4036 75.1014 41.7968 75.0958 42.3457C75.0874 43.1864 74.0792 43.5566 73.1386 43.5712C71.4935 43.597 70.5389 43.1317 69.7781 42.7805L69.1853 45.5244C69.9494 45.872 71.3603 46.174 72.824 46.1894C76.2602 46.1894 78.5084 44.5082 78.5196 41.905ZM64.9694 33.4713L59.6692 45.9936H56.2106L53.6026 35.9999C53.4441 35.3844 53.3064 35.1593 52.8249 34.8997C52.0392 34.4776 50.7404 34.0808 49.5977 33.8351L49.6757 33.4713H55.242C55.9513 33.4713 56.5897 33.939 56.7506 34.7479L58.1283 41.9946L61.5324 33.4713H64.9694Z",
    fill: "#1434CB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_4302_41854)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 21,
    width: 57.4328,
    height: 37,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 20.5,
    width: 58.4328,
    height: 38,
    rx: 8.5,
    stroke: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.841 31.9022H131.385V47.0981H139.841V31.9022Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.922 39.5001C131.92 38.0366 132.252 36.592 132.892 35.2757C133.531 33.9593 134.462 32.8057 135.613 31.9021C134.187 30.7815 132.475 30.0847 130.672 29.8911C128.869 29.6976 127.048 30.0153 125.417 30.8078C123.786 31.6003 122.411 32.8358 121.449 34.3729C120.487 35.91 119.977 37.6868 119.977 39.5001C119.977 41.3135 120.487 43.0903 121.449 44.6274C122.411 46.1645 123.786 47.3999 125.417 48.1924C127.048 48.985 128.869 49.3026 130.672 49.1091C132.475 48.9156 134.187 48.2187 135.613 47.0981C134.462 46.1945 133.531 45.0409 132.892 43.7246C132.252 42.4082 131.92 40.9636 131.922 39.5001Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.249 39.5001C151.249 41.3134 150.739 43.0902 149.777 44.6273C148.815 46.1644 147.44 47.3999 145.809 48.1924C144.178 48.9849 142.357 49.3026 140.554 49.1091C138.751 48.9156 137.039 48.2187 135.613 47.0981C136.763 46.1936 137.693 45.0398 138.332 43.7237C138.972 42.4075 139.304 40.9634 139.304 39.5001C139.304 38.0369 138.972 36.5927 138.332 35.2766C137.693 33.9604 136.763 32.8066 135.613 31.9021C137.039 30.7815 138.751 30.0846 140.554 29.8911C142.357 29.6976 144.178 30.0153 145.809 30.8078C147.44 31.6004 148.815 32.8358 149.777 34.3729C150.739 35.91 151.249 37.6868 151.249 39.5001Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.327 45.4886V45.1775H150.452V45.1141H150.133V45.1775H150.258V45.4886H150.327ZM150.947 45.4886V45.1135H150.849L150.736 45.3715L150.624 45.1135H150.526V45.4886H150.595V45.2057L150.701 45.4496H150.772L150.878 45.205V45.4886H150.947Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4302_41854",
    x: 0,
    y: 0,
    width: 140,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4302_41854"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4302_41854",
    result: "effect2_dropShadow_4302_41854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4302_41854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_4302_41854",
    x: 66,
    y: 0,
    width: 139.434,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4302_41854"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4302_41854",
    result: "effect2_dropShadow_4302_41854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4302_41854",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.72d447e79c239eb2b938cb507803d41f.svg";
export { ForwardRef as ReactComponent };